import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

const StyledBox = styled(Box)(({ theme }) => ({
  '& .DLLHeaderLink': {
    display: 'inline-block',
  },
  '& .DLInternationLocations': {
    backgroundColor: theme.palette.background.secondary,
    padding: theme.spacing(16, 0),
    '&.DLRemoveBg': {
      backgroundColor: 'unset',
      padding: 0,
    },
  },
  '& .DLLocationsTitle': {
    textTransform: 'uppercase',
    color: theme.palette.common.white,
    marginBottom: theme.spacing(6),
  },
}));

export default StyledBox;
